import * as React from "react";

import { useNavigate } from "react-router-dom";
import updateImage from "../../../images/update.svg";
import deleteImage from "../../../images/delete.svg";
import TrainingListLoader from "../../loader/tableLoader";

export default function TableBody({
  trainingsList,
  deleteTraining,
  loading,
}) {
  let navigate = useNavigate();

  return (
    <div
      style={{
        height: "64vh",
        overflow: "Scroll",
        boxShadow: "10px 20px 30px #888888",
        borderRadius: "10px",
      }}
    >
      {!loading ? (
        trainingsList?.length > 0 &&
        trainingsList?.map((currentTrainingDetails, index) => {
          return (
            <div
              style={{ width: "100%", display: "flex" }}
              key={currentTrainingDetails.id}
            >
              <div
                style={{
                  width: "35%",
                  padding: "15px",
                  borderBottom: "1px solid grey",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                  // borderRadius:"0 0 0 10px"
                }}
              >
                <p>          {currentTrainingDetails.title}</p>
              </div>
              <div
                style={{
                  width: "15%",
                  padding: "15px",
                  borderBottom: "1px solid grey",

                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              ><p>{currentTrainingDetails.type}

                </p></div>
              <div
                style={{
                  width: "25%",
                  padding: "15px",
                  borderBottom: "1px solid grey",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >

                <p>{`${currentTrainingDetails.duration} ${currentTrainingDetails.durationTypeWMY}`}</p></div>
              <div
                style={{
                  width: "15%",
                  padding: "15px",
                  borderBottom: "1px solid grey",

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <p>   {currentTrainingDetails.totalSessions}</p>
              </div>
              <div
                style={{
                  width: "10%",
                  padding: "15px",
                  borderBottom: "1px solid grey",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div>
                  <img
                    src={updateImage}
                    onClick={() => {
                      if (currentTrainingDetails.id) {

                        if(currentTrainingDetails.type==="Bootcamp"){



                        
                          navigate(`/training/${currentTrainingDetails.id}`, {
                            replace: true,
                          });
                        }else{ navigate(`/training/editRocketSeries/${currentTrainingDetails.id}`, {
                          replace: true,
                        });

                        }

                      }
                    }}
                    style={{ cursor: "pointer", marginRight: "20px" }}
                    height={15}
                    width={15}
                  />
                  <img
                    src={deleteImage}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      deleteTraining({
                        id: currentTrainingDetails.id,
                        index,
                        type:currentTrainingDetails.type
                      });
                    }}
                    height={15}
                    width={15}
                  />
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <TrainingListLoader />
      )}
    </div>


  );
}
